import { differenceInMilliseconds, startOfToday as getStartOfToday, startOfTomorrow as getStartOfTomorrow, } from 'date-fns';
import { useEffect, useState } from 'react';
export function useStartOfToday() {
    const [startOfToday, setStartOfToday] = useState(getStartOfToday());
    useEffect(() => {
        const startOfTomorrow = getStartOfTomorrow();
        const now = new Date(Date.now());
        const timeout = differenceInMilliseconds(startOfTomorrow, now);
        const handle = window.setTimeout(() => {
            setStartOfToday(startOfTomorrow);
        }, timeout);
        return () => {
            window.clearTimeout(handle);
        };
    }, [startOfToday, setStartOfToday]);
    return startOfToday;
}
